import React, { FC } from 'react'
import { RouteComponentProps } from 'react-router-dom'
import { FaEnvelopeOpenText } from 'react-icons/fa'
import { IoClose } from 'react-icons/io5'

import Modal from 'react-modal'
import TemplatesModal from '../../Dashboard/Prospects/UserInfo/Templates'
import { Prospects as ProspectsStore } from '../../../stores/prospects'

interface Props extends RouteComponentProps {
  prospects?: ProspectsStore
  open: boolean
  currentType: string
  handleClose: () => void
}

const EmailTemplatesModal: FC<Props> = props => {
  const { open, currentType, handleClose, prospects, match, location, history } = props
  return (
    <Modal
      id="maneuver-modal"
      isOpen={open}
      className="maneuver_modal template"
      ariaHideApp={false}
    >
      <div className="maneuver-modal-header">
        <div className="maneuver-modal-header-title" id="contained-modal-title-vcenter">
          <FaEnvelopeOpenText className="user-icon" style={{ marginRight: 10 }} />
          {`${currentType} MISSION EMAIL TEMPLATES`}
        </div>
        <div className="maneuver-modal-header-close" id="contained-modal-title-vcenter">
          <IoClose
            className="user-icon"
            style={{ marginRight: 10 }}
            onClick={(): void => handleClose()}
          />
        </div>
      </div>
      <div className="modal-body">
        <TemplatesModal {...{ prospects, history, match, location, currentType }} />
      </div>
    </Modal>
  )
}

export default EmailTemplatesModal
